const wizardMutations = {
    setState(state, { prop, value }) {
        state[prop] = value;
    },
    setSelected(state, { prop, value }) {
        state.selected[prop] = value;
    },
    setRegistration(state, payload) {
        state.registration = {
            ...payload,
            personal: {
                ...state.selected.user
            }
        };
    }
};

export default wizardMutations;
